import { useEffect } from 'react';
import { Button, Typography, Card, theme } from 'antd';
import { keycloak } from '../auth/keycloak';
import { useAuthStore } from '../stores/auth-store';
import { useT } from '../locales';

const { Title, Text } = Typography;

export function LoginPage() {
  const t = useT();
  const { isAuthenticated, isInitialized } = useAuthStore();
  const { token } = theme.useToken();

  useEffect(() => {
    if (isAuthenticated) {
      window.location.href = '/';
    }
  }, [isAuthenticated]);

  const handleLogin = () => {
    keycloak.login({ redirectUri: window.location.origin + '/' });
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: token.colorBgLayout,
        padding: 24,
      }}
    >
      <Card
        style={{
          maxWidth: 420,
          width: '100%',
          borderRadius: 14,
          border: `1px solid ${token.colorBorderSecondary}`,
        }}
        styles={{
          body: {
            padding: '44px 36px 36px',
            textAlign: 'center',
          },
        }}
      >
        <div
          aria-hidden
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 48,
            height: 48,
            borderRadius: 12,
            background: token.colorPrimary,
            color: token.colorTextLightSolid,
            fontWeight: 700,
            fontSize: 22,
            marginBottom: 20,
            boxShadow: token.boxShadow,
          }}
        >
          a
        </div>
        <Title
          level={2}
          style={{
            margin: 0,
            fontSize: 24,
            fontWeight: 600,
            letterSpacing: '-0.015em',
          }}
        >
          {t('app.name')}
        </Title>
        <Text type="secondary" style={{ display: 'block', marginTop: 8, fontSize: 14 }}>
          {t('app.tagline')}
        </Text>
        <div style={{ marginTop: 28 }}>
          <Button type="primary" size="large" onClick={handleLogin} loading={!isInitialized} block>
            {t('auth.loginButton')}
          </Button>
        </div>
      </Card>
    </div>
  );
}
